<template>
  <ContactPage />
</template>
<script>
import ContactPage from "@/components/ContactPage.vue";
const components = {
  ContactPage,
};
export default {
  name: "contact",
  components,
};
</script>
